import { render, staticRenderFns } from "./IndustryNews.vue?vue&type=template&id=5ba0ad34&scoped=true"
import script from "./IndustryNews.vue?vue&type=script&lang=js"
export * from "./IndustryNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0ad34",
  null
  
)

export default component.exports